const EMAILJS_ENDPOINT = 'https://api.emailjs.com/api/v1.0/email/send'

const EMAILJS_SERVICE_ID = 'service_0g5nqkj'
const EMAILJS_TEMPLATE_ID = 'template_fopx2is'
const EMAILJS_NEWSLETTER_TEMPLATE_ID = 'template_soqwd47'
const EMAILJS_PUBLIC_KEY = 'tY_qZ27nRz0DSypl7'

export interface ContactEmailParams {
  name: string
  email: string
  subject?: string
  interest?: string
  message: string
}

/**
 * Sends a contact submission via the EmailJS REST API (no SDK).
 * Your EmailJS template should reference these variables:
 * {{name}} {{email}} {{subject}} {{interest}} {{message}} {{time}}
 */
export const sendContactEmail = async (params: ContactEmailParams): Promise<void> => {
  const res = await fetch(EMAILJS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: {
        name: params.name,
        email: params.email,
        subject: params.subject || 'N/A',
        interest: params.interest || 'N/A',
        message: params.message,
        time: new Date().toLocaleString('en-GB', {
          dateStyle: 'medium',
          timeStyle: 'short',
        }),
      },
    }),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`Email failed to send. ${text || res.status}`.trim())
  }
}

/**
 * Notifies the team of a newsletter signup via a dedicated EmailJS template.
 * Your EmailJS template should reference these variables: {{email}} {{time}}
 */
export const sendNewsletterSignup = async (email: string): Promise<void> => {
  const res = await fetch(EMAILJS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_NEWSLETTER_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: {
        email,
        time: new Date().toLocaleString('en-GB', {
          dateStyle: 'medium',
          timeStyle: 'short',
        }),
      },
    }),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`Newsletter signup failed. ${text || res.status}`.trim())
  }
}
